import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const COMMON_API = {
  uploadFileAPI: async (params: any) => {
    const response = await new AxiosClient().post('/files/upload-multimedia', params)
    const data = get(response, 'data', null)
    return data
  },
}

export default COMMON_API
